module.exports = __webpack_public_path__ + "img/deleted_user.f151f1ee.svg";